import { useEffect, useState } from 'react';

import { Field, ErrorMessage, useFormikContext } from 'formik';

import { api, useAPIContext } from '../../api/context';
import toast from '../../utils/toast';

const Division = ({ loading }) => {

  const { token } = useAPIContext();
  const [ _loading, _setLoading ] = useState(true);

  const DEFAULT = 'Division';
  const [ label, setLabel ] = useState(DEFAULT);
  const [ items, setItems ] = useState([]);

  const { values: { country }, setFieldValue } = useFormikContext();

  useEffect(() => {

    _setLoading(true);

    if (!country) {
      setLabel(DEFAULT);
      setItems([]);
      setFieldValue('division', '');
      return;
    }

    api(token).v1.profile.countries.obtain({ country })
      .then(res => {
        if (res.status === 200) {
          _setLoading(false);
          setLabel(res.body.labels.division);
          setItems(res.body.divisions);
        }
      })
      .catch(err => {
        toast.show(toast.KIND.WARNING, err);
      });

  }, [country, setFieldValue, token]);

  return (
    <div>
      <label htmlFor='division'>{label}</label>

      <Field
        id='division'
        as='select'
        aria-label={label.toLowerCase()}
        name='division'
        disabled={loading || _loading}>

        <option key='' value=''></option>

        {
          items.map(item => (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          ))
        }

      </Field>

      <ErrorMessage
        name='division'
        component='div'
      />
    </div>
  );
};

export default Division;